// extracted by mini-css-extract-plugin
module.exports = {"date-group":"date-group__2bsCe","date":"date__1KqvC","date-no":"date-no__1vkrL","body":"body__3971r"};